// Generated by purs version 0.15.16
import * as API_Autofill from "../API.Autofill/index.js";
import * as API_Expectations from "../API.Expectations/index.js";
import * as API_SelEmployer from "../API.SelEmployer/index.js";
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React from "../Concur.React/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Combinators from "../Data.Argonaut.Decode.Combinators/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as $$Error from "../Error/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_ConcurUtil from "../Internal.ConcurUtil/index.js";
import * as Internal_JsonUtil from "../Internal.JsonUtil/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Internal_Util from "../Internal.Util/index.js";
import * as Translate from "../Translate/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_EmployerModal from "../Widgets.EmployerModal/index.js";
import * as Widgets_Form_Class from "../Widgets.Form.Class/index.js";
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var label = /* #__PURE__ */ Concur_React_DOM.label(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var map = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var groupOptsByKey = /* #__PURE__ */ Widgets_BetterSelect.groupOptsByKey(Data_Ord.ordString);
var runGraphQL = /* #__PURE__ */ GraphQL_Join.runGraphQL(GraphQL_Query.qgql);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)));
var gDecodeJsonCons2 = /* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var positionsIsSymbol = {
    reflectSymbol: function () {
        return "positions";
    }
};
var deleted_atIsSymbol = {
    reflectSymbol: function () {
        return "deleted_at";
    }
};
var contactsIsSymbol = {
    reflectSymbol: function () {
        return "contacts";
    }
};
var companyIsSymbol = {
    reflectSymbol: function () {
        return "company";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var getEmployer = /* #__PURE__ */ API_SelEmployer.getEmployer(/* #__PURE__ */ GraphQL_Query.jsonQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(nameIsSymbol)()())(idIsSymbol)()())())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Internal_Luxon.decodeLDT))(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(labelIsSymbol)()())(idIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(positionsIsSymbol)()())(idIsSymbol)()())(deleted_atIsSymbol)()())(contactsIsSymbol)()())(companyIsSymbol)()())())(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(positionsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(deleted_atIsSymbol)(/* #__PURE__ */ GraphQL_Shape.maybeShape(GraphQL_Shape.scalarShape))()())(contactsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(nameIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(companyIsSymbol)(GraphQL_Shape.scalarShape)()())()));
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(/* #__PURE__ */ Concur_Core_Types.monadEffectWidget(Data_Monoid.monoidArray));
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var alt = /* #__PURE__ */ Control_Alt.alt(/* #__PURE__ */ Concur_Core_Types.altWidget(Data_Monoid.monoidArray));
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Maybe.bindMaybe);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var eqRNTY = /* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString);
var eqMaybe = /* #__PURE__ */ Data_Maybe.eqMaybe(eqRNTY);
var eq2 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons({
    reflectSymbol: function () {
        return "types";
    }
})(/* #__PURE__ */ Data_Eq.eqArray(API_Autofill.aftEq)))()({
    reflectSymbol: function () {
        return "teacher_id";
    }
})(eqMaybe))()({
    reflectSymbol: function () {
        return "student_id";
    }
})(eqRNTY))()({
    reflectSymbol: function () {
        return "position_id";
    }
})(eqMaybe))()({
    reflectSymbol: function () {
        return "form";
    }
})(eqRNTY))()({
    reflectSymbol: function () {
        return "employer_id";
    }
})(eqMaybe))()({
    reflectSymbol: function () {
        return "courses";
    }
})(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons({
    reflectSymbol: function () {
        return "index";
    }
})(Data_Eq.eqInt))()(idIsSymbol)(eqRNTY)))))()({
    reflectSymbol: function () {
        return "contact_id";
    }
})(eqMaybe)));
var bind2 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var getFieldOptional$prime = /* #__PURE__ */ Data_Argonaut_Decode_Combinators["getFieldOptional$prime"](Data_Argonaut_Decode_Class.decodeJsonJson);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var map4 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Either.applicativeEither);
var AutoSelect = /* #__PURE__ */ (function () {
    function AutoSelect(value0) {
        this.value0 = value0;
    };
    AutoSelect.create = function (value0) {
        return new AutoSelect(value0);
    };
    return AutoSelect;
})();
var ASNoChange = /* #__PURE__ */ (function () {
    function ASNoChange() {

    };
    ASNoChange.value = new ASNoChange();
    return ASNoChange;
})();
var ASDeselect = /* #__PURE__ */ (function () {
    function ASDeselect() {

    };
    ASDeselect.value = new ASDeselect();
    return ASDeselect;
})();
var AutoFillSelect = function (x) {
    return x;
};
var showAFS = {
    show: function (v) {
        return "AutoFillSelect " + v.id;
    }
};
var renderSubSelect = function (fc) {
    return function (state) {
        return function (subsel) {
            var selState = (function () {
                var v = Widgets_BetterSelect.selectedItem(state.select);
                if (v instanceof Data_Maybe.Just) {
                    return Widgets_BetterSelect.setSearchAff(subsel.select)(subsel.selAff(fc)(v.value0.value));
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return Widgets_BetterSelect.setSearchAff(subsel.select)(Widgets_BetterSelect.emptySearchAff);
                };
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 350, column 16 - line 352, column 61): " + [ v.constructor.name ]);
            })();
            return div([ Concur_React_Props.className("search-subform-select-wrapper") ])([ label([ Concur_React_Props.htmlFor(state.select.id) ])([ text(subsel.label) ]), map(function (v) {
                return {
                    autoSel: subsel.autoSel,
                    funcs: subsel.funcs,
                    id: subsel.id,
                    label: subsel.label,
                    selAff: subsel.selAff,
                    select: v
                };
            })(Widgets_BetterSelect.selectWidget(selState)) ]);
        };
    };
};
var renderAutoFillSelect = function (fc) {
    return function (state) {
        var selectedId = function (state$prime) {
            return map1(map2(state$prime.def.funcs.itemId)(function (v) {
                return v.value;
            }))(Widgets_BetterSelect.selectedItem(state$prime.select));
        };
        var selState = Widgets_BetterSelect.setSearchAff(state.select)(state.def.selAff(fc));
        var handleSubSel = function (idx) {
            return function (sub) {
                return map(function (sub$prime) {
                    return {
                        def: state.def,
                        fillAnyway: state.fillAnyway,
                        id: state.id,
                        select: state.select,
                        subsels: Data_Maybe.fromMaybe([  ])(Data_Array.updateAt(idx)(sub$prime)(state.subsels))
                    };
                })(renderSubSelect(fc)(state)(sub));
            };
        };
        var applyAutoSel = function (sel) {
            return function (sub) {
                var v = sub.autoSel(fc)(sel);
                if (v instanceof AutoSelect) {
                    return {
                        id: sub.id,
                        label: sub.label,
                        funcs: sub.funcs,
                        selAff: sub.selAff,
                        autoSel: sub.autoSel,
                        select: Widgets_BetterSelect.setSelected(sub.select)(new Data_Maybe.Just({
                            label: sub.funcs.itemLabel(v.value0),
                            value: v.value0
                        }))
                    };
                };
                if (v instanceof ASDeselect) {
                    return {
                        id: sub.id,
                        label: sub.label,
                        funcs: sub.funcs,
                        selAff: sub.selAff,
                        autoSel: sub.autoSel,
                        select: Widgets_BetterSelect.setSelected(sub.select)(Data_Maybe.Nothing.value)
                    };
                };
                if (v instanceof ASNoChange) {
                    return sub;
                };
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 326, column 28 - line 331, column 26): " + [ v.constructor.name ]);
            };
        };
        var maybeApplyAutoSels = function (v) {
            if (eq(selectedId(v))(selectedId(state))) {
                return v;
            };
            var selItem = map1(function (v1) {
                return v1.value;
            })(Widgets_BetterSelect.selectedItem(v.select));
            return {
                def: v.def,
                fillAnyway: v.fillAnyway,
                id: v.id,
                select: v.select,
                subsels: map3(applyAutoSel(selItem))(v.subsels)
            };
        };
        var runButton = function (btn) {
            return bind(btn(fc))(function (ent) {
                var v = map1(function (e) {
                    return {
                        label: state.def.funcs.itemLabel(e),
                        value: e
                    };
                })(ent);
                if (v instanceof Data_Maybe.Just) {
                    return pure(maybeApplyAutoSels({
                        id: state.id,
                        subsels: state.subsels,
                        def: state.def,
                        select: Widgets_BetterSelect.setSelected(state.select)(new Data_Maybe.Just(v.value0)),
                        fillAnyway: true
                    }));
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return pure(state);
                };
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 336, column 9 - line 339, column 34): " + [ v.constructor.name ]);
            });
        };
        return div([ Concur_React_Props.className("autofill-select search-subform-search") ])(append1([ div([ Concur_React_Props.className("search-subform-select-wrapper") ])(append1([ label([ Concur_React_Props.htmlFor(state.select.id) ])([ text(state.def.label) ]), map(map2(maybeApplyAutoSels)(function (v) {
            return {
                def: state.def,
                fillAnyway: state.fillAnyway,
                id: state.id,
                subsels: state.subsels,
                select: v
            };
        }))(Widgets_BetterSelect.selectWidget(selState)) ])((function () {
            if (state.select.config.editable) {
                return map3(runButton)(state.def.buttons(map1(function (v) {
                    return v.value;
                })(Widgets_BetterSelect.selectedItem(state.select))));
            };
            return [  ];
        })())) ])(Data_Array.mapWithIndex(handleSubSel)(state.subsels)));
    };
};
var initAutoFillSelect = function (v) {
    return function (def) {
        return {
            id: v.id,
            select: Widgets_BetterSelect["initGroupedSelect$prime"](v.id + "-af-select")(Widgets_BetterSelect.emptySearchAff)(def.groupFunc)({
                deselectLabel: Widgets_BetterSelect.defSelectConfig.deselectLabel,
                allowDeselect: Widgets_BetterSelect.defSelectConfig.allowDeselect,
                editable: Widgets_BetterSelect.defSelectConfig.editable,
                placeholder: new Data_Maybe.Just(Translate.lookupTranslation("select-choose-search"))
            }),
            subsels: def.subsels,
            def: def,
            fillAnyway: false
        };
    };
};
var courseAutoFillSelect = function (init) {
    return initAutoFillSelect(init)({
        label: Translate.lookupTranslation("course-form-course"),
        types: [ API_Autofill.CoursesAF.value ],
        funcs: {
            apply: function (fc) {
                return function (v) {
                    return function (v1) {
                        return {
                            form: v1.form,
                            student_id: v1.student_id,
                            teacher_id: v1.teacher_id,
                            employer_id: v1.employer_id,
                            position_id: v1.position_id,
                            contact_id: v1.contact_id,
                            types: v1.types,
                            courses: [ {
                                index: fc.curIndex,
                                id: v.id
                            } ]
                        };
                    };
                };
            },
            itemId: function ($364) {
                return GraphQL_Type.innerId((function (v) {
                    return v.id;
                })($364));
            },
            itemLabel: function (v) {
                return v.label;
            },
            load: function (fc) {
                return function (id) {
                    return bind1(fc.doc)(function (doc) {
                        return bind1(Data_Array.find(function (c) {
                            return GraphQL_Type.innerId(c.id) === id;
                        })(doc.courses))(function (c) {
                            return pure1(API_Expectations.expCourseToGroup(c));
                        });
                    });
                };
            }
        },
        selAff: function (fc) {
            return API_Expectations.courseListSelAff(Data_Maybe.maybe(GraphQL_Type.dummyId)(function (v) {
                return v.student.id;
            })(fc.doc));
        },
        groupFunc: new Data_Maybe.Just(groupOptsByKey(function (v) {
            return v.group_label;
        })(function (v) {
            return v.group_label;
        })),
        subsels: [  ],
        buttons: function (v) {
            return [  ];
        }
    });
};
var asaFunctor = {
    map: function (v) {
        return function (v1) {
            if (v1 instanceof AutoSelect) {
                return new AutoSelect(v(v1.value0));
            };
            if (v1 instanceof ASDeselect) {
                return ASDeselect.value;
            };
            if (v1 instanceof ASNoChange) {
                return ASNoChange.value;
            };
            throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 204, column 1 - line 207, column 34): " + [ v.constructor.name, v1.constructor.name ]);
        };
    }
};
var map5 = /* #__PURE__ */ Data_Functor.map(asaFunctor);
var initSubSelect = function (v) {
    var selAff = function (fc) {
        return function (a) {
            return Widgets_BetterSelect.mapSearchAff(Unsafe_Coerce.unsafeCoerce)(Widgets_BetterSelect.rankByLabel)(v.selAff(fc)(a));
        };
    };
    var itemLabel = function ($365) {
        return v.funcs.itemLabel($365);
    };
    return {
        id: v.id,
        label: v.label,
        select: Widgets_BetterSelect["initSelect$prime"](v.id + "-af-select")(Widgets_BetterSelect.emptySearchAff)({
            deselectLabel: Widgets_BetterSelect.defSelectConfig.deselectLabel,
            allowDeselect: Widgets_BetterSelect.defSelectConfig.allowDeselect,
            editable: Widgets_BetterSelect.defSelectConfig.editable,
            placeholder: new Data_Maybe.Just(Translate.lookupTranslation("select-choose-search"))
        }),
        funcs: {
            apply: function (fc) {
                var $366 = v.funcs.apply(fc);
                return function ($367) {
                    return $366($367);
                };
            },
            itemId: function ($368) {
                return v.funcs.itemId($368);
            },
            itemLabel: itemLabel,
            load: function (fc) {
                var $369 = map1(Unsafe_Coerce.unsafeCoerce);
                var $370 = v.funcs.load(fc);
                return function ($371) {
                    return $369($370($371));
                };
            }
        },
        autoSel: function (fc) {
            var $372 = map5(Unsafe_Coerce.unsafeCoerce);
            var $373 = v.autoSel(fc);
            return function ($374) {
                return $372($373($374));
            };
        },
        selAff: selAff
    };
};
var employerAutoFillSelect = function (init) {
    var loadEmployer = function (fc) {
        return function (id) {
            var tagctx = (function () {
                var $375 = $$Error.tagWidget("AutoFillSelect");
                var $376 = $$Error.tagAction("while loading added/edited employer info");
                return function ($377) {
                    return $375($376($377));
                };
            })();
            return bind(map(tagctx)(Concur_React.affAction(runGraphQL(getEmployer(id)(GraphQL_Type.maybeId(map1(function (v) {
                return v.id;
            })(fc.doc)))(GraphQL_Type.maybeId(map1(function (v) {
                return v.student.id;
            })(fc.doc)))))))(function (empM) {
                if (empM instanceof Data_Either.Right) {
                    return pure(new Data_Maybe.Just(empM.value0));
                };
                if (empM instanceof Data_Either.Left) {
                    return bind(liftEffect($$Error.reportError(empM.value0)))(function () {
                        return pure(Data_Maybe.Nothing.value);
                    });
                };
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 137, column 9 - line 141, column 29): " + [ empM.constructor.name ]);
            });
        };
    };
    var editBtn = function (fc) {
        return function (emp) {
            var btn = button([ Concur_React_Props.className("btn employer-edit-btn"), Concur_React_Props.onClick ])([ text(Translate.lookupTranslation("edit-employer") + emp.company) ]);
            return bind(btn)(function () {
                return bind(alt(Widgets_EmployerModal.employerCreateModal(new Data_Maybe.Just(emp.id)))(Internal_ConcurUtil.loopInfinitely(btn)))(function (eid) {
                    if (eid instanceof Data_Maybe.Just) {
                        return loadEmployer(fc)(eid.value0);
                    };
                    if (eid instanceof Data_Maybe.Nothing) {
                        return pure(Data_Maybe.Nothing.value);
                    };
                    throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 127, column 9 - line 129, column 36): " + [ eid.constructor.name ]);
                });
            });
        };
    };
    var addBtn = function (fc) {
        var btn = button([ Concur_React_Props.className("btn employer-add-btn"), Concur_React_Props.onClick ])([ text(Translate.lookupTranslation("add-employer")) ]);
        return bind(btn)(function () {
            return bind(alt(Widgets_EmployerModal.employerCreateModal(Data_Maybe.Nothing.value))(Internal_ConcurUtil.loopInfinitely(btn)))(function (eid) {
                if (eid instanceof Data_Maybe.Just) {
                    return loadEmployer(fc)(eid.value0);
                };
                if (eid instanceof Data_Maybe.Nothing) {
                    return pure(Data_Maybe.Nothing.value);
                };
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 115, column 9 - line 117, column 36): " + [ eid.constructor.name ]);
            });
        });
    };
    var buttons = function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return [ addBtn ];
        };
        if (v instanceof Data_Maybe.Just) {
            return Data_Array.catMaybes([ Internal_Util.justIf(Data_Maybe.isNothing(v.value0.deleted_at))(function (fc) {
                return editBtn(fc)(v.value0);
            }), new Data_Maybe.Just(addBtn) ]);
        };
        throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 101, column 5 - line 101, column 77): " + [ v.constructor.name ]);
    };
    return initAutoFillSelect(init)({
        label: Translate.lookupTranslation("employer-form-employer"),
        types: [ API_Autofill.EmployerAF.value, API_Autofill.ContactAF.value, API_Autofill.PositionAF.value ],
        funcs: {
            apply: function (v) {
                return function (e) {
                    return function (v1) {
                        return {
                            form: v1.form,
                            student_id: v1.student_id,
                            teacher_id: v1.teacher_id,
                            position_id: v1.position_id,
                            contact_id: v1.contact_id,
                            courses: v1.courses,
                            types: v1.types,
                            employer_id: new Data_Maybe.Just(e.id)
                        };
                    };
                };
            },
            itemId: function ($378) {
                return GraphQL_Type.innerId((function (v) {
                    return v.id;
                })($378));
            },
            itemLabel: function (v) {
                return v.company;
            },
            load: function (fc) {
                return function (v) {
                    return bindFlipped(function (v1) {
                        return v1.employer;
                    })(fc.doc);
                };
            }
        },
        selAff: function (fc) {
            return API_SelEmployer.employerPosConSearchSelAff(Data_Maybe.maybe(GraphQL_Type.dummyId)(function (v) {
                return v.id;
            })(fc.doc))(Data_Maybe.maybe(GraphQL_Type.dummyId)(function (v) {
                return v.student.id;
            })(fc.doc));
        },
        groupFunc: Data_Maybe.Nothing.value,
        subsels: [ initSubSelect({
            id: "position",
            label: Translate.lookupTranslation("position"),
            funcs: {
                apply: function (v) {
                    return function (p) {
                        return function (v1) {
                            return {
                                form: v1.form,
                                student_id: v1.student_id,
                                teacher_id: v1.teacher_id,
                                employer_id: v1.employer_id,
                                contact_id: v1.contact_id,
                                courses: v1.courses,
                                types: v1.types,
                                position_id: new Data_Maybe.Just(p.id)
                            };
                        };
                    };
                },
                itemId: function ($379) {
                    return GraphQL_Type.innerId((function (v) {
                        return v.id;
                    })($379));
                },
                itemLabel: function (v) {
                    return v.label;
                },
                load: function (fc) {
                    return function (v) {
                        return bindFlipped(function (v1) {
                            return v1.position;
                        })(fc.doc);
                    };
                }
            },
            selAff: function (fc) {
                return function (employer) {
                    return API_SelEmployer.positionSelAff(GraphQL_Type.maybeId(map1(function (v) {
                        return v.id;
                    })(fc.doc)))(GraphQL_Type.maybeId(map1(function (v) {
                        return v.student.id;
                    })(fc.doc)))(employer.id);
                };
            },
            autoSel: function (v) {
                return function (e) {
                    return Data_Maybe.maybe(ASDeselect.value)(AutoSelect.create)(bindFlipped(Data_Array.head)(map1(function (v1) {
                        return v1.positions;
                    })(e)));
                };
            }
        }), initSubSelect({
            id: "contact",
            label: Translate.lookupTranslation("employer-contact"),
            funcs: {
                apply: function (v) {
                    return function (c) {
                        return function (v1) {
                            return {
                                form: v1.form,
                                student_id: v1.student_id,
                                teacher_id: v1.teacher_id,
                                employer_id: v1.employer_id,
                                position_id: v1.position_id,
                                courses: v1.courses,
                                types: v1.types,
                                contact_id: new Data_Maybe.Just(c.id)
                            };
                        };
                    };
                },
                itemId: function ($380) {
                    return GraphQL_Type.innerId((function (v) {
                        return v.id;
                    })($380));
                },
                itemLabel: function (v) {
                    return v.name;
                },
                load: function (fc) {
                    return function (v) {
                        return bindFlipped(function (v1) {
                            return v1.contact;
                        })(fc.doc);
                    };
                }
            },
            selAff: function (fc) {
                return function (employer) {
                    return API_SelEmployer.contactSelAff(GraphQL_Type.maybeId(map1(function (v) {
                        return v.id;
                    })(fc.doc)))(GraphQL_Type.maybeId(map1(function (v) {
                        return v.student.id;
                    })(fc.doc)))(employer.id);
                };
            },
            autoSel: function (v) {
                return function (e) {
                    return Data_Maybe.maybe(ASDeselect.value)(AutoSelect.create)(bindFlipped(Data_Array.head)(map1(function (v1) {
                        return v1.contacts;
                    })(e)));
                };
            }
        }) ],
        buttons: buttons
    });
};
var applyAutofillArgs = function (fc) {
    return function (state) {
        var noop = function (x) {
            return x;
        };
        var applyTypes = function (v) {
            return {
                form: v.form,
                student_id: v.student_id,
                teacher_id: v.teacher_id,
                employer_id: v.employer_id,
                position_id: v.position_id,
                contact_id: v.contact_id,
                courses: v.courses,
                types: state.def.types
            };
        };
        var applySubSel = function (sub) {
            return Data_Maybe.maybe(noop)(sub.funcs.apply(fc))(map1(function (v) {
                return v.value;
            })(Widgets_BetterSelect.selectedItem(sub.select)));
        };
        var applySubSels = function (af) {
            return foldl(Data_Function.flip(applySubSel))(af)(state.subsels);
        };
        var applyMainSel = Data_Maybe.maybe(noop)(state.def.funcs.apply(fc))(map1(function (v) {
            return v.value;
        })(Widgets_BetterSelect.selectedItem(state.select)));
        return function ($381) {
            return applyTypes(applySubSels(applyMainSel($381)));
        };
    };
};
var runAutoFillSelect = function (fc) {
    return function (oldState) {
        return bind(renderAutoFillSelect(fc)(oldState))(function (newState) {
            var oldArgs = applyAutofillArgs(fc)(oldState)(fc.autofillArgs);
            var newArgs = applyAutofillArgs(fc)(newState)(fc.autofillArgs);
            return pure((function () {
                var $332 = eq2(oldArgs)(newArgs) && !newState.fillAnyway;
                if ($332) {
                    return Widgets_Form_Class.formWidgetState(newState);
                };
                return Widgets_Form_Class.formWidgetAction({
                    id: newState.id,
                    select: newState.select,
                    subsels: newState.subsels,
                    def: newState.def,
                    fillAnyway: false
                })(new Widgets_Form_Class.FWAutoFill(newArgs));
            })());
        });
    };
};
var afsFW = {
    getId: function (v) {
        return v.id;
    },
    isLeaf: function (v) {
        return true;
    },
    asField: function (v) {
        return new Data_Maybe.Just(new GraphQL_Shape.QScalar(v.id));
    },
    fieldPaths: function (fc) {
        return function (v) {
            return [ Widgets_Form_Class.fieldId(fc)(v.id) ];
        };
    },
    toWidget: function (fc) {
        return function (v) {
            var editable = Widgets_Form_Class.fieldCanUpdate(fc)(v.id);
            var setEditable = function (sel) {
                return {
                    id: sel.id,
                    search: sel.search,
                    searchAff: sel.searchAff,
                    groupFunc: sel.groupFunc,
                    selected: sel.selected,
                    highlighted: sel.highlighted,
                    expanded: sel.expanded,
                    hovering: sel.hovering,
                    loadNext: sel.loadNext,
                    options: sel.options,
                    state: sel.state,
                    config: {
                        placeholder: sel.config.placeholder,
                        deselectLabel: sel.config.deselectLabel,
                        allowDeselect: sel.config.allowDeselect,
                        editable: editable
                    }
                };
            };
            var editableState = {
                def: v.def,
                fillAnyway: v.fillAnyway,
                id: v.id,
                select: setEditable(v.select),
                subsels: map3(function (sub) {
                    return {
                        autoSel: sub.autoSel,
                        funcs: sub.funcs,
                        id: sub.id,
                        label: sub.label,
                        selAff: sub.selAff,
                        select: setEditable(sub.select)
                    };
                })(v.subsels)
            };
            return runAutoFillSelect(fc)(editableState);
        };
    },
    getData: function (v) {
        return function (v1) {
            return Data_Maybe.fromMaybe(Data_Argonaut_Core.jsonNull)(map1(map2(map2(Data_Argonaut_Core.fromString)(v1.def.funcs.itemId))(function (v2) {
                return v2.value;
            }))(Widgets_BetterSelect.selectedItem(v1.select)));
        };
    },
    setData: function (v) {
        return function (v1) {
            return function (v2) {
                if (Data_Argonaut_Core.isNull(v2)) {
                    return new Data_Either.Right(v1);
                };
                var wrapOpt = function (v3) {
                    return function (opt) {
                        return {
                            label: v3.funcs.itemLabel(opt),
                            value: opt
                        };
                    };
                };
                var loadSubSel = function (obj) {
                    return function (sub) {
                        return bind2(bind2(getFieldOptional$prime(obj)(sub.id + "Id"))(function (v3) {
                            if (v3 instanceof Data_Maybe.Nothing) {
                                return pure2(Data_Maybe.Nothing.value);
                            };
                            if (v3 instanceof Data_Maybe.Just) {
                                return map4(Data_Maybe.Just.create)(Internal_JsonUtil.numberToString(v3.value0));
                            };
                            throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 399, column 66 - line 401, column 56): " + [ v3.constructor.name ]);
                        }))(function (v3) {
                            var $353 = eq(map1(map2(sub.funcs.itemId)(function (v4) {
                                return v4.value;
                            }))(Widgets_BetterSelect.selectedItem(sub.select)))(v3);
                            if ($353) {
                                return pure2(sub);
                            };
                            return pure2({
                                funcs: sub.funcs,
                                id: sub.id,
                                autoSel: sub.autoSel,
                                label: sub.label,
                                selAff: sub.selAff,
                                select: Widgets_BetterSelect.setSelected(sub.select)(map1(wrapOpt(sub))(bindFlipped(sub.funcs.load(v))(v3)))
                            });
                        });
                    };
                };
                var loadObj = function (obj) {
                    return bind2(bind2(getFieldOptional$prime(obj)("id"))(function (v3) {
                        if (v3 instanceof Data_Maybe.Nothing) {
                            return pure2(Data_Maybe.Nothing.value);
                        };
                        if (v3 instanceof Data_Maybe.Just) {
                            return map4(Data_Maybe.Just.create)(Internal_JsonUtil.numberToString(v3.value0));
                        };
                        throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 383, column 54 - line 385, column 56): " + [ v3.constructor.name ]);
                    }))(function (v3) {
                        var oldSel = Widgets_BetterSelect.selectedItem(v1.select);
                        var mainSel = (function () {
                            var $357 = eq(map1(map2(v1.def.funcs.itemId)(function (v4) {
                                return v4.value;
                            }))(oldSel))(v3);
                            if ($357) {
                                return oldSel;
                            };
                            return map1(wrapOpt(v1.def))(bindFlipped(v1.def.funcs.load(v))(v3));
                        })();
                        return bind2(traverse(loadSubSel(obj))(v1.subsels))(function (subsels) {
                            return pure2({
                                id: v1.id,
                                def: v1.def,
                                fillAnyway: v1.fillAnyway,
                                select: Widgets_BetterSelect.setSelected(v1.select)(mainSel),
                                subsels: subsels
                            });
                        });
                    });
                };
                return $$Error["wrapJsonError$prime"](v2)(bind2(Internal_JsonUtil.assertObject(v2))(function (obj) {
                    var $358 = Foreign_Object.member("id")(obj);
                    if ($358) {
                        return loadObj(obj);
                    };
                    return pure2(v1);
                }));
            };
        };
    }
};
var afSelectedId = function (v) {
    return map1(map2(v.def.funcs.itemId)(function (v1) {
        return v1.value;
    }))(Widgets_BetterSelect.selectedItem(v.select));
};
export {
    courseAutoFillSelect,
    employerAutoFillSelect,
    initAutoFillSelect,
    AutoSelect,
    ASNoChange,
    ASDeselect,
    initSubSelect,
    AutoFillSelect,
    afSelectedId,
    runAutoFillSelect,
    applyAutofillArgs,
    renderAutoFillSelect,
    renderSubSelect,
    asaFunctor,
    showAFS,
    afsFW
};
//# sourceMappingURL=index.js.map
